"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ImportedCustomerProfileDto = void 0;
const LocationDto_1 = require("../locations/LocationDto");
const AppDto_1 = require("../apps/AppDto");
class ImportedCustomerProfileDto {
    constructor(params) {
        if (!params) {
            return;
        }
        this.id = params.id;
        this.appId = params.appId;
        this.locationId = params.locationId;
        this.mimeType = params.mimeType;
        this.data = params.data;
        this.createdAt = params.createdAt;
        this.updatedAt = params.updatedAt;
        if (params.app !== undefined) {
            this.app = params.app = params.app === null ?
                null :
                new AppDto_1.AppDto(params.app);
        }
        if (params.location !== undefined) {
            this.location = params.location = params.location === null ?
                null :
                new LocationDto_1.LocationDto(params.location);
        }
    }
}
exports.ImportedCustomerProfileDto = ImportedCustomerProfileDto;
//# sourceMappingURL=ImportedCustomerProfileDto.js.map